<template>
    <!-- 订单管理-票券核销记录 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'ticketVerifyRecord')">
        <div slot="header">
            <a-form :form="form" layout="inline" >
            <a-form-item label="用户票券id">
                <a-input placeholder="请输入" v-decorator="['verifyObject']" @pressEnter="search(false)"></a-input>
            </a-form-item>
            <a-form-item label="票券名称">
                <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search(false)"></a-input>
            </a-form-item>
            <a-form-item label="手机号">
                <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search(false)"></a-input>
            </a-form-item>
            <a-form-item label="预约使用门店">
                <a-select allowClear placeholder="请选择" v-decorator="['reserveShopId']" @select="search(false)">
                    <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="核销门店">
                <a-select allowClear placeholder="请选择" v-decorator="['verifyShopId']" @select="search(false)">
                    <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="预约使用时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY/MM/DD"
                    v-decorator="['reserveDate']"
                    @cahnge="search(false)"
                />
            </a-form-item>
            <a-form-item label="核销时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY/MM/DD"
                    v-decorator="['verifyDate']"
                    @change="search(false)"
                />
            </a-form-item>
            <a-form-item class="wrap-header-button">
                <a-button @click="search(false)" class="mr8" type="primary" :loading="loading">筛选</a-button>
                <a-button @click="handleReset">重置</a-button>
            </a-form-item>
            </a-form>
        </div>
        <a-card :bordered="false">
                <template slot="extra" v-if="getBtnByAuth('ticketVerifyExport')">
                    <a-button type="primary" @click="search(true)" :loading="loading">导出excel</a-button>
                    <a-button @click="openExportModal">导出记录</a-button>
                </template>
            <a-table :scroll="{y: 540}" style="word-break:break-all;" :loading="loading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                <span slot="platform" slot-scope="platform, row">{{!platform ? "-" : platform == "收银台" ? row.shopName : platform}}</span>
                <span slot="isFlag" slot-scope="isFlag">{{['否','是'][Number(isFlag)]}}</span>
                <span slot="orderNum" slot-scope="orderNum, row">{{row.reserveNo ? row.verifyNum : "-"}}</span>
                <span slot="empty" slot-scope="empty">{{empty || "-"}}</span>
                <span slot="action" slot-scope="text, row">
                    <span v-if="getBtnByAuth('verifyReservationRecord')">
                        <a class="text-primary" v-if="row.reserveNo" @click="openModal(row, false)">预约记录</a>
                        <span v-else class="text-disabled">预约记录</span>
                    </span>
                    <a-divider type="vertical" v-if="getBtnByAuth('verifyReservationRecord') && getBtnByAuth('ticketVerifyReturn')"/>
                    <span v-if="getBtnByAuth('ticketVerifyReturn')">
                        <a v-if="row.returnNum < row.verifyNum" class="text-primary" @click="openModal(row, true)">次数退还</a>
                        <span v-else class="text-disabled">次数退还</span>
                    </span>
                </span>
            </a-table>
            <count-refund @closeModalCountRefund="closeModalCountRefund" @closeModal="closeModal" :id="currentRow.id" :maxNum="currentRow.verifyNum - currentRow.returnNum" :visibleCountRefund="visible" />
        </a-card>
        <a-modal
            title="预约记录"
            :visible="visibleOrderRecord"
            width="1000px"
            @cancel="visibleOrderRecord=false"
            :footer="false">
            <a-table bordered :dataSource="orderList" :columns="columnsOrder" :pagination="false" :rowKey="(record, index) => index">
                <span slot="index" slot-scope="a, row, index">{{index + 1 }}</span>
                <span slot="orderNum">1</span>
                <span slot="empty" slot-scope="empty">{{empty || "-"}}</span>
            </a-table>
        </a-modal>
        <report-export-modal ref="reportExportModal" :exportType="3"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    const columns = [
    {
        title: "用户票券id",
        dataIndex: "verifyObject"
    },
    {
        title: "票券名称",
        dataIndex: "name"
    },
    {
        title: "会员手机号",
        dataIndex: "phone",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "核销人",
        dataIndex: "useUserPhone",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "购买途径",
        dataIndex: "platform",
        scopedSlots: { customRender: "platform" }
    },
    {
        title: "核销门店",
        dataIndex: "verifyShopName",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "核销票台",
        dataIndex: "verifyPlatformName",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "预约次数",
        dataIndex: "orderNum",
        scopedSlots: { customRender: "orderNum" }
    },
    {
        title: "核销次数",
        dataIndex: "verifyNum",
        scopedSlots: { customRender: "verifyNum" }
    },
    {
        title: "退还次数",
        dataIndex: "returnNum",
        scopedSlots: { customRender: "returnNum" }
    },
    {
        title: "是否强制核销",
        dataIndex: "isForce",
        scopedSlots: { customRender: "isFlag" }
    },
    {
        title: "是否购买门店核销",
        dataIndex: "isBuyShopVerify",
        scopedSlots: { customRender: "isFlag" }
    },
    {
        title: "是否适用门店核销",
        dataIndex: "isSuitShopVerify",
        scopedSlots: { customRender: "isFlag" }
    },
    {
        title: "核销时间",
        dataIndex: "verifyTime",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "操作人",
        dataIndex: "cashier",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    const columnsOrder = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "预约使用时间",
            dataIndex: "reserveDate",
            scopedSlots: { customRender: "reserveDate" }
        },
        {
            title: "预约场次",
            dataIndex: "reservePeriod",
            scopedSlots: { customRender: "reservePeriod" }
        },
        {
            title: "预约门店",
            dataIndex: "reserveShopName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "预约次数",
            dataIndex: "orderNum",
            scopedSlots: { customRender: "orderNum" }
        },
    ]
    import moment  from 'moment';
    import countRefund from '@/components/modules/order/count-refund.component';
    export default {
        name: "ticketVerifyRecord",
        components: {
            countRefund
        },
        props: {},
        data() {
            return {
                columns,
                columnsOrder,
                dataSource: [],
                shopList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                visible: false,
                visibleOrderRecord: false,
                currentRow: {},
                num: null,
                orderList: [],
            };
        },
        computed: {
            'maxNum'() {
                // 当未核销时，可退还最多次数为预约次数；当核销后，可退还最多次数为实际核销次数
                // 实际核销次数可能会大于预约次数，因为有强制核销
                // appointmentUsage 预约次数
                // actualUsage 实际使用次数
                // return this.currentRow.actualUsage ? (this.currentRow.appointmentUsage < this.currentRow.actualUsage ? 0 : this.currentRow.appointmentUsage - this.currentRow.actualUsage) : this.currentRow.appointmentUsage
                // 方案二
                return this.currentRow.actualUsage > 0 ? this.currentRow.actualUsage : this.currentRow.appointmentUsage
            }
        },
        filters: {
            dateSplit(val) {
                if (!val) return "";
                return val.substring(11);
            }
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },

            handleReset() {
                this.pagination.pageSize = 20
                this.pagination.current = 1
                this.form.resetFields();
                this.getList(false);
            },
            search(isExport) {
                this.pagination.current = 1;
                this.getList(isExport);
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                });
            },
            // 获取使用订单列表
            getList(isExport) {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const verifyDate = values['verifyDate'] ? values['verifyDate'] : []
                    values.verifyStartTime = verifyDate.length > 0 ? verifyDate[0].format('YYYY-MM-DD') : undefined
                    values.verifyEndTime = verifyDate.length > 0 ? verifyDate[1].format('YYYY-MM-DD') : undefined

                    const reserveDate = values['reserveDate'] ? values['reserveDate'] : []
                    values.reserveStartTime = reserveDate.length > 0 ? reserveDate[0].format('YYYY-MM-DD') : undefined
                    values.reserveEndTime = reserveDate.length > 0 ? reserveDate[1].format('YYYY-MM-DD') : undefined
                    this.loading = true;

                    delete values.verifyDate
                    delete values.reserveDate
                    this.$api.order.getTicketVerifyList({
                        query: Object.assign(values,
                        {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                        })
                    }).then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                        if (Boolean(isExport)) {
                            this.exportExcel();
                        }
                    }).catch(err => {
                        this.loading = false;
                    })
                });
            },

            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const verifyDate = values['verifyDate'] ? values['verifyDate'] : []
                    values.verifyStartTime = verifyDate.length > 0 ? verifyDate[0].format('YYYY-MM-DD') : undefined
                    values.verifyEndTime = verifyDate.length > 0 ? verifyDate[1].format('YYYY-MM-DD') : undefined

                    const reserveDate = values['reserveDate'] ? values['reserveDate'] : []
                    values.reserveStartTime = reserveDate.length > 0 ? reserveDate[0].format('YYYY-MM-DD') : undefined
                    values.reserveEndTime = reserveDate.length > 0 ? reserveDate[1].format('YYYY-MM-DD') : undefined

                    delete values.reserveDate
                    delete values.verifyDate
                    this.loading = true;
                    this.$api.order.ticketVerifyExport({
                        query: Object.assign(values,
                        {
                            pageNum: 1,
                            pageSize: this.pagination.total
                        })
                    },
                    )
                    .then(res => {
                        this.openExportModal();
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },
            getOrderList() {
                if (!this.currentRow.reserveObject && !this.currentRow.verifyObject) return;
                let verifyNo = this.currentRow.id;
                this.loading = true;
                this.$api.order.getVerifyReserveList({
                    body: {
                        pageNum: 1,
                        pageSize: 9999,
                        verifyId: verifyNo,
                    }
                }).then(res => {
                    this.loading = false;
                    this.orderList = res.list;
                }).catch(err => {
                    this.loading = false;
                })
            },
            openModal(row, type) {
                this.currentRow = row
                // type true 次数退还， false 预约记录;
                if (type) {
                    this.visible = true
                } else {
                    this.visibleOrderRecord = true
                    this.getOrderList();
                }
            },
            closeModal() {
                this.visible = false
                setTimeout(() => {
                    this.getList()
                }, 500);
            },
            closeModalCountRefund() {
                this.visible = false
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getShopList()
            this.getList()
        }
    };
</script>
<style lang="scss">
</style>
